module.exports = __webpack_public_path__ + "img/cbd.97dcf2c7.png";